module.exports = __webpack_public_path__ + "img/Facebook.46eb522c.svg";